import {
  PRODUCTS_FETCH,
  PRODUCTS_FETCH_START,
  PRODUCTS_FETCH_DONE,
} from "../constants/actionTypes";
import { FetchProductsType, Product } from "../types/product";

export function doFetchProducts(payload: FetchProductsType) {
  return { type: PRODUCTS_FETCH, payload };
}

export function doFetchProductsStart() {
  return { type: PRODUCTS_FETCH_START };
}

export function doFetchProductsDone(payload: Product[]) {
  return { type: PRODUCTS_FETCH_DONE, payload };
}
